function getIsValidHexColor(_hex_) {
  return /^#([0-9a-f]{3}){1,2}$/i.test(_hex_);
}

const hexToRgb = (_hex_: string) => {
  const isValidHexColor = getIsValidHexColor(_hex_);

  if (!isValidHexColor) {
    // console.warn(
    //   `%c ${_hex_ ||
    //     'undefined'} is not a valid hex color. rgb(0, 0, 0) will be returned.`,
    //   'background: #ff0000; color: #bada55'
    // );
  }

  let hex: string | string[] = isValidHexColor ? _hex_ : '#000';
  //
  if (hex.length === 4) {
    hex = hex.replace('#', '').split('');
    hex = `#${hex
      .map(entry => {
        return `${entry}${entry}`;
      })
      .join('')}`;
  }

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return ['r', 'g', 'b'].reduce((acc, curr, i) => {
    return {
      ...acc,
      [curr]: !result ? 0 : parseInt(result[i + 1], 16),
    };
  }, {}) as any;
};

const getHexToRgbWithDefaultFallback = (
  hex: string,
  defaultColor: string = '#fff'
) => {
  const isValidHexColor = getIsValidHexColor(hex);

  if (!isValidHexColor) {
    console.warn(
      `%c ${hex ||
        'undefined'} is not a valid hex color. the default color will be returned as rgb(. . .)`,
      'background: #ff0000; color: #bada55'
    );
  }

  if (!isValidHexColor) {
    return hexToRgb(defaultColor);
  }

  return hexToRgb(hex);
};

export default hexToRgb;
export { getHexToRgbWithDefaultFallback };
